module.exports = __webpack_public_path__ + "img/Olimpic Movement.e2fb72be.png";